import { Editor } from '@meitu/saas-editor-core';
import { type ImageEnhancePlugin } from '@meitu/saas-editor-core/es/layers/main-layer/plugins/apps/user-editor/image-enhance';

export const useBatchActionHooks = () => {
    const batchAction = async (
        editor: Editor,
        newParams: any,
        onStageLoading?: (stageIndex: number, isBatch: boolean) => void,
        setIsDisable?: (isDisable: boolean) => void,
        batchSetIsLoading?: (stageIndex: number[]) => void,
    ) => {
        setIsDisable?.(true);
        const imageEnhance = editor.getInstance<ImageEnhancePlugin>('ImageEnhancePlugin');

        editor.services.mask.show({
            loading: true,
        });
        const stageList = editor.services.frame.getRenderFrameIds();
        batchSetIsLoading?.(stageList);

        await new Promise((resolve) => {
            setTimeout(async () => {
                await imageEnhance.basicEnhance.batchAction(newParams, onStageLoading);
                const originLayer = imageEnhance.getState().originLayer;
                if (originLayer) {
                    await imageEnhance.basicEnhance.create(originLayer, undefined, true);
                    await imageEnhance.basicEnhance.action({});
                }

                onStageLoading?.(stageList[0], false);
                editor.services.mask.hide();
                setIsDisable?.(false);
                resolve(true);
            }, 10);
        });

        editor.services.mask.hide();
        setIsDisable?.(false);
    };

    return {
        batchAction,
    };
};
